import Cookies from 'js-cookie';
import AuthApi from "./AuthApi";

const get = require("lodash.get");

const USUARIO_KEY = "usuario_portal";
const AUTH_PUBLIC_COOKIE = 'portal_auth_public';

class Auth {
    constructor() {
        this.authApi = new AuthApi();
    }

    async login(login, senha) {
        try {
            const { usuario } = await this.authApi.autenticar(login, senha);
            localStorage.setItem(USUARIO_KEY, JSON.stringify(usuario));
        } catch (err) {
            console.log(err);
            const mensagem = get(err, 'response.data.mensagem', 'Houve um erro ao fazer login. Por favor tente novamente')
            throw mensagem;
        }
    }

    logout() {
        try {
            localStorage.removeItem(USUARIO_KEY);
            Cookies.remove(AUTH_PUBLIC_COOKIE)
        } catch (err) {
            console.log(err);
            const mensagem = get(err, 'response.data.mensagem', 'Houve um erro ao fazer logout. Por favor tente novamente')
            throw mensagem;
        }
    }

    loggedIn() {
        return !!this.usuario && Cookies.get(AUTH_PUBLIC_COOKIE);
    }

    get usuario() {
        const usuarioString = localStorage.getItem(USUARIO_KEY);
        if (usuarioString) {
            return JSON.parse(usuarioString);
        }
        return null;
    }
}

export default Auth;